<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Copy Token</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">

	    	<v-text-field
	    		:value="$root.CurrentBusiness.BusinessID"
	    	  	label="Business ID"
	    	></v-text-field>
	    	
	    	<v-text-field
	    		:value="token"
	    	  	label="Token"
	    	></v-text-field>

	    	<v-text-field
	    		:value="fcmToken"
	    	  	label="FCM Token"
	    	></v-text-field>

	    	<v-text-field
	    		:value="deviceId"
	    	  	label="Device ID"
	    	></v-text-field>

	    	<div>Device Name: {{deviceInfo.DeviceName}}</div>
	    	<div>Android Version: {{deviceInfo.AndroidVersion}}</div>

	    	<v-btn color="primary" @click="fn_getToken">Referesh Token</v-btn>
	    	
	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				token:null,
				fcmToken:null,
				deviceId:null
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_getToken: function(){
				let self = this;
				this.showLoading('Getting Token...');
				this.$root.fn_getAuthToken(function(token){
	                self.token = token;
	                self.fn_getFcmToken();
	            });
			},

			fn_getFcmToken: function(){
				let self = this;
	            this.getData('GetFcmToken', null, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.fcmToken = response;
	                        self.deviceId = AndroidRoutingTest.getDeviceId();
	                        self.hideLoading();
	                    }, 
	                    onError: function(error){
	                    	self.hideLoading();
	                    	self.showToast("Error in fcm token");
	                        console.log(error);
	                    }
	                }
	            );
			},
		},
	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_getToken();
	  	}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/copy_token.vue